/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { generateSimplestList } from '@touchplan/common';
import { SplitData } from '@touchplan/common';

export enum LaborCountRenderType {
	database = 'database',
}

export interface LaborCountFields {
	color?: string;
	roleId: string;
	plannedAndActual: number;
	date: string;
}

export class LaborCount extends SplitData<LaborCountFields, LaborCountRenderType> {
	protected attributeList = Object.assign(
		generateSimplestList(['roleId', 'plannedAndActual', 'date', 'color']),
		{}
	);
	constructor(id: string) {
		super(id, LaborCountRenderType.database);
	}

	public databaseUpdate(data: Object) {
		const massagedData: LaborCountFields[] = [];
		for (const roleKey in data) {
			const plannedAndActual =
				data[roleKey].plannedAndActual !== undefined
					? data[roleKey].plannedAndActual
					: data[roleKey].plannedAndLastPlanned;
			massagedData[roleKey] = {
				roleId: roleKey,
				//color: "",
				plannedAndActual,

				date: this.$id,
			};
		}
		return super.databaseUpdate(massagedData);
	}

	public localUpdate(data: Object, renderType?: LaborCountRenderType) {
		return super.localUpdate(data, renderType);
	}
}
